var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from "react";
import PropTypes from "prop-types";
import Helpers from "../victory-util/helpers";
import pathHelpers from "./path-helpers";
import CommonProps from "./common-props";
import Path from "./path";

var Point = function (_React$Component) {
  _inherits(Point, _React$Component);

  function Point() {
    _classCallCheck(this, Point);

    return _possibleConstructorReturn(this, (Point.__proto__ || Object.getPrototypeOf(Point)).apply(this, arguments));
  }

  _createClass(Point, [{
    key: "getPath",
    value: function getPath(props) {
      var datum = props.datum,
          active = props.active,
          x = props.x,
          y = props.y;

      var size = Helpers.evaluateProp(props.size, datum, active);
      if (props.getPath) {
        return props.getPath(x, y, size);
      }
      var pathFunctions = {
        circle: pathHelpers.circle,
        square: pathHelpers.square,
        diamond: pathHelpers.diamond,
        triangleDown: pathHelpers.triangleDown,
        triangleUp: pathHelpers.triangleUp,
        plus: pathHelpers.plus,
        minus: pathHelpers.minus,
        star: pathHelpers.star
      };
      var symbol = Helpers.evaluateProp(props.symbol, datum, active);
      var symbolFunction = typeof pathFunctions[symbol] === "function" ? pathFunctions[symbol] : pathFunctions.circle;
      return symbolFunction(x, y, size);
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          active = _props.active,
          datum = _props.datum,
          role = _props.role,
          shapeRendering = _props.shapeRendering,
          className = _props.className,
          events = _props.events,
          pathComponent = _props.pathComponent;

      var style = Helpers.evaluateStyle(this.props.style, datum, active);
      var d = this.getPath(this.props);
      return React.cloneElement(pathComponent, { style: style, role: role, shapeRendering: shapeRendering, className: className, events: events, d: d });
    }
  }]);

  return Point;
}(React.Component);

Point.propTypes = _extends({}, CommonProps, {
  datum: PropTypes.object,
  getPath: PropTypes.func,
  pathComponent: PropTypes.element,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  symbol: PropTypes.oneOfType([PropTypes.oneOf(["circle", "diamond", "plus", "minus", "square", "star", "triangleDown", "triangleUp"]), PropTypes.func]),
  x: PropTypes.number,
  y: PropTypes.number
});
Point.defaultProps = {
  pathComponent: React.createElement(Path, null)
};
export default Point;


//////////////////
// WEBPACK FOOTER
// /~/victory-core/es/victory-primitives/point.js
// module id = NbK/
// module chunks = 0